import React from 'react';
import Button from './Button';
import { X } from 'lucide-react';

const PopUp = ({ children, title, isVisible, setIsVisible, needConfirm = false, confirmAction = () => { }, cancelAction = () => setIsVisible(false), cannotClose = false, needXL = false }) => {

    const handleOverlayClick = (e) => {
        // Chiudi solo se needConfirm è false e cannotClose è false
        if (!needConfirm && !cannotClose && e.target === e.currentTarget) {
            setIsVisible(false);
        }
    };

    // Funzione per prevenire la chiusura quando si clicca all'interno del popup
    const handlePopupClick = (e) => {
        e.stopPropagation();
    };
    
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] back no-row-action" onClick={handleOverlayClick}>
            <div className={`bg-gray-100 dark:bg-neutral-900 text-black dark:text-white rounded-lg shadow-lg p-4 w-[90%] ${needXL ? 'md:w-[70%]' : 'md:w-[40%]'}`} onClick={handlePopupClick}>
                <div className={`flex items-center mb-2 ${needConfirm || cannotClose ? 'justify-center' : 'justify-between'}`}>
                    <div className="text-2xl font-semibold ">{title}</div>
                    {!needConfirm && !cannotClose && (
                        <Button type="icon" onClick={() => setIsVisible(false)}><X size={28}/></Button>
                    )}
                </div>
                <div className={`max-h-[75vh] overflow-y-auto`}>
                    {children}
                </div>
                {needConfirm && !cannotClose && (
                    <div className="grid grid-cols-2 gap-2 mt-4">
                        <Button type="hollow" onClick={cancelAction}>ANNULLA</Button>
                        <Button type="full" onClick={confirmAction}>CONFERMA</Button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PopUp;